import type { Group, LoadingManager } from '@seddi/three';
import log from 'loglevel';

import { load } from './modelLoader';
import type { ModelDesc } from './modelTypes';
import { ResourceManager } from './resourceManager';

/**
 * Model resources context.
 */
export class ModelsContext extends ResourceManager<Group> {
  readonly manager: LoadingManager;

  constructor(manager: LoadingManager) {
    super();
    this.manager = manager;
  }

  /**
   * Load model.
   * @param desc - Descriptor.
   */
  async loadAsync(desc: ModelDesc): Promise<Group | undefined> {
    if (this.find(desc.id)) {
      log.warn(`ModelsContext.loadAsync: ${desc.id} is not new.`);
      return undefined;
    }

    const item = this.create(desc.id);
    item.status = 'loading';

    const value = await load(desc, this.manager);
    item.status = 'ready';
    item.value = value;

    if (this.onLoad) {
      this.onLoad(desc.id, 'Model');
    }

    return value;
  }
}
